import React, { lazy, Suspense } from 'react';
import Confirm from '@sonifi/wb-notifier/components/Confirm';
import Alert from '@sonifi/wb-notifier/components/Alert';
import {
  ALERTS_IDS,
  CONFIRMS_IDS,
} from '@sonifi/wb-notifier/constants/notifierConstants';
import WbIdle from '@sonifi/wb-widget/components/WbIdle/WbIdle';
import useWbAppLayout from '../hooks/useWbAppLayout';
import RouteLoadingManager from '../routes/RoutingManager';
import { DndProvider } from 'react-dnd';
import { manager } from '@sonifi/wb-widget/components/WbDragAndDrop/dnd-manager';

const WbLogin = lazy(() => import('@sonifi/wb-login/wb-login'));

const AppLayout = ({ children }) => {
  const { wrapperClass } = useWbAppLayout();

  return (
    <>
      <header className="header-nav">
        {children}
        <Suspense>
          <WbLogin />
        </Suspense>
      </header>
      <div className={`content-wrapper ${wrapperClass}`}>
        <WbIdle />
        <Alert scope={ALERTS_IDS.wbapp} />
        <Confirm scope={CONFIRMS_IDS.wbapp} />
        <main>
          <DndProvider manager={manager}>
            <RouteLoadingManager />
          </DndProvider>
        </main>
        <div className="clearfix"></div>
      </div>
      <footer>
        <div>
          Copyright &copy; <span id="copyrightYear"></span> SONIFI Solutions
          Inc. All Rights Reserved.
        </div>
      </footer>
    </>
  );
};

export default AppLayout;
